'use strict'
const omit_ = require('lodash/omit')

const id = x => x

module.exports = (
  Raven,
  breadCrumbCallback = id
) => store => next => action => {
  Raven.captureBreadcrumb(
    breadCrumbCallback({
      category: 'redux',
      message: action.type,
      data: omit_(action, 'type', 'record')
    })
  )

  return next(action)
}



// WEBPACK FOOTER //
// ../node_modules/dbsm-common/src/raven/middleware.js